import { selectFeatureFlag } from '../../selectors/feature-flags';

export const getisFFPlacesNotificationsPageEnabled = state =>
  selectFeatureFlag(state, 'enable-places-notifications-page');
export const getDisableHealthMap = state => selectFeatureFlag(state, 'disable-health-map');
export const getDisableBrakeplusMap = state => selectFeatureFlag(state, 'disable-brakeplus-map');
